export default __webpack_public_path__ + "static/media/eA1C.2b9e7afd.svg";